// extracted by mini-css-extract-plugin
module.exports = {"assistance_items_container":"AssistanceTable_assistance_items_container__3j8wA","assistance_item_container":"AssistanceTable_assistance_item_container__nIBno"};